export enum UsageInterval {
    OneMinute = '1m',
    FifteenMinutes = '15m',
    ThirtyMinutes = '30m',
    OneHour = '1h',
    OneDay = '1d',
}
